module.exports = __webpack_public_path__ + "static/media/circle-status-canceled.a9b6c0da.svg";